"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as o } from "react";
import r from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ e(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 1.25a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5m-.913 13.059 6.571-6.492c.25-.252.288-.592-.006-.912 0 0-1.077-1.069-1.138-1.128-.26-.257-.653-.213-.908.05l-4.963 4.898L8.4 10.512a.673.673 0 0 0-.942.02l-1.132 1.117a.65.65 0 0 0 .02.93l3.799 3.75a.67.67 0 0 0 .942-.02",
        clipRule: "evenodd"
      }
    )
  }
), a = o(m);
export {
  a as CheckmarkCircle,
  a as default
};
